import { Component, ElementRef, ViewChild } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'piqet-angular-grid-cell-input',
  templateUrl: './grid-cell-input.component.html',
  styleUrls: ['./grid-cell-input.component.css'],
})
export class GridCellInputComponent {
  params: any;
  rowData: any;
  rowValue: any;
  litterImpactObj: any;
  data: any;

  @ViewChild('inputField', { static: false }) inputField!: ElementRef;

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    switch (this.params.colDef.field) {
      case 'landfill':
        this.data = this.params.data.landfill || 0;
        break;
      case 'recycling':
        this.data = this.params.data.recycling || 0;
        break;
      case 'homeComposting':
        this.data = this.params.data.homeComposting || 0;
        break;
      case 'commercialComposting':
        this.data = this.params.data.commercialComposting || 0;
        break;
      case 'incineration':
        this.data = this.params.data.incineration || 0;
        break;
      case 'wasteEnergyRecovery':
        this.data = this.params.data.wasteEnergyRecovery || 0;
        break;
      case 'openDump':
        this.data = this.params.data.openDump || 0;
        break;
      case 'anerobicDigestion':
        this.data = this.params.data.anerobicDigestion || 0;
        break;
      case 'litter':
        this.data = this.params.data.litter || 0;
        break;
      case 'stormWater':
        this.data = this.params.data.stormWater || 0;
        break;
      case 'sewer':
        this.data = this.params.data.sewer || 0;
        break;
      case 'recyclingOpenLoop':
        this.data = this.params.data.recyclingOpenLoop || 0;
        break;
      case 'chemicalRecycling':
        this.data = this.params.data.chemicalRecycling || 0;
        break;
      case 'pyrolysis':
        this.data = this.params.data.pyrolysis || 0;
        break;
      case 'openBurning':
        this.data = this.params.data.openBurning || 0;
        break;
      case 'none':
        this.data = this.params.data.none || 0;
        break;
    }
    this.rowData = params?.data;
  }

  refresh(params: ICellRendererParams): boolean {
    if (this.params.api && this.params.api.getEditingCells().length === 0) {
      this.inputField.nativeElement.focus();
    }
    return true;
  }

  onInputChange(event: any) {
    const input = event.target;
    const cursorPosition = input.selectionStart;
    let value = input.value;

    const cleanValue = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');

    if (cleanValue !== value) {
      this.data = cleanValue;
      setTimeout(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      }, 0);
    }
  }

  updateCellRecord(data: any) {
    this.params.data = JSON.parse(JSON.stringify(this.params.data));
    switch (this.params.colDef.field) {
      case 'landfill':
        this.params.data.landfill = data;
        break;
      case 'recycling':
        this.params.data.recycling = data;
        break;
      case 'homeComposting':
        this.params.data.homeComposting = data;
        break;
      case 'commercialComposting':
        this.params.data.commercialComposting = data;
        break;
      case 'incineration':
        this.params.data.incineration = data;
        break;
      case 'wasteEnergyRecovery':
        this.params.data.wasteEnergyRecovery = data;
        break;
      case 'openDump':
        this.params.data.openDump = data;
        break;
      case 'anerobicDigestion':
        this.params.data.anerobicDigestion = data;
        break;
      case 'litter':
        this.params.data.litter = data;
        break;
      case 'stormWater':
        this.params.data.stormWater = data;
        break;
      case 'sewer':
        this.params.data.sewer = data;
        break;
      case 'recyclingOpenLoop':
        this.params.data.recyclingOpenLoop = data;
        break;
      case 'chemicalRecycling':
        this.params.data.chemicalRecycling = data;
        break;
      case 'pyrolysis':
        this.params.data.pyrolysis = data;
        break;
      case 'openBurning':
        this.params.data.openBurning = data;
        break;
      case 'none':
        this.params.data.none = data;
        break;
    }
    this.params?.updateData(this.params.data);
  }
}
